import axios from "axios";
const BASE_URI = process.env.REACT_APP_BASE_URI;

const headersAppLd = {
    headers: {
        "Content-Type": "application/ld+json",
    },
};

export const deleteRecipe = async (id: string) => {
    const url = BASE_URI + "/api/recipes/" + id;
    const datas = {};

    try {
        const { data } = await axios.delete(url, datas);
        return { status: true, response:data.response };
    } catch (error: any) {
        const message =
            error.response && error.response.data.message
                ? error.response.data.message
                : error.message;

        return { status: false, error: message };
    }
};

export const getRecipes = async () => {
    const url = BASE_URI + "/api/recipes";
    const datas = {};

    try {
        const { data } = await axios.get(url, datas);
        return { status: true, response: "success", fetchedRecipes: data["hydra:member"] };
    } catch (error: any) {
        const message =
            error.response && error.response.data.message
                ? error.response.data.message
                : error.message;

        return { status: false, message: message, response: "error" };
    }
};

export const createRecipe = async (datas: object) => {
    const url = BASE_URI + "/api/recipes/save-info";
    const datasToSend = datas;

    try {
        const { data } = await axios.post(url, datasToSend, headersAppLd);
        return { status: true, id: data.id };
    } catch (error: any) {
        const message =
            error.response && error.response.data.message
                ? error.response.data.message
                : error.message;

        return { status: false, message: message, response: "error" };
    }
};

export const modifyRecipe = async (id:string, datas: object) => {
    const url = BASE_URI + "/api/recipes/" + id;
    const datasToSend = datas;

    try {
        const { data } = await axios.put(url, datasToSend, headersAppLd);
        return { status: true, id: data.id };
    } catch (error: any) {
        const message =
            error.response && error.response.data.message
                ? error.response.data.message
                : error.message;

        return { status: false, message: message, response: "error" };
    }
};
